import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";
import { get } from "src/utils/networkUtils";

export default function LevelOverallLeaderboardTable() {
  const [loading, setLoading] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    setLoading(true);
    get(`/admin/user-level/leaderboard?limit=50`)
      .then(function (response) {
        setLeaderboard(response.leaderboard || []);
        setLoading(false);
      })
      .catch(function (error) {
        console.error("Error fetching leaderboard:", error);
        setLeaderboard([]);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Rank</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>Points</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leaderboard.length > 0 ? (
            leaderboard.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell component="th" scope="row">
                  <a href={`/dashboard/profile?user_id=${row.userId}`}>
                    {row.username}
                  </a>
                </TableCell>
                <TableCell component="th" scope="row">
                  {Math.round(row.points * 100) / 100}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
